import * as Moment from 'moment';

export function isValid(jahr: number, von: number, bis: number): boolean {
    const minVon = Moment(`01-07-${jahr - 1}`, 'DD-MM-YYYY').unix();
    const maxVon = Moment(`01-01-${+jahr + 1}`, 'DD-MM-YYYY').unix();
    const minBis = Moment(`01-01-${jahr}`, 'DD-MM-YYYY').unix();
    const maxBis = Moment(`01-07-${+jahr + 1}`, 'DD-MM-YYYY').unix();

    if (
        (jahr && bis !== -1 && (+jahr !== +Moment(bis, 'X').year() && (bis > maxBis || bis < minBis)))
        || (jahr && von !== -1 && (+jahr !== +Moment(von, 'X').year() && (von > maxVon || von < minVon)))
        || (+von > +bis)
    ) {
        return false;
    }

    return true;
}
